import { Component, inject } from "@angular/core";
import { SidebarStateService } from "../../../services/sidebar-state.service";

@Component({
    selector: 'app-sidebar-minimizer',
    standalone: true,
    templateUrl: './app-sidebar-minimizer.component.html',
    imports: []
})
export class AppSidebarMinimizerComponent {
    private sidebarStateService = inject(SidebarStateService);

    constructor() {
    }

    public toggleMenu() {
        const menuMinimized = this.isMenuMinimized();
        const nextState = !menuMinimized;
        if (nextState) {
          localStorage.setItem("menu.minimized", "true");
        } else {
          localStorage.removeItem("menu.minimized");
        }
        this.sidebarStateService.notifyMenuMinimizedChange(nextState);
    }

    public isMenuMinimized(): boolean {
        return localStorage.getItem("menu.minimized") === "true";
    }

}
